<!-- TimelineButton.vue -->
<template>
  <button
      data-bs-toggle="collapse"
      data-bs-target="#collapseWidthExample"
      :class="`timeline-btn ${isActive ? 'active' : ''}`"
      @click="$emit('click')"
  >
    {{ label }}
  </button>
</template>

<script>
export default {
  name: "TimelineButton",
  props: {
    label: {
      type: String,
      required: true
    },
    isActive: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style>
.timeline-btn {
  background-color: var(--accent-primary);
  border: none;
  border-radius: var(--radius-button);
  color: #fff;
  padding: 10px 20px;
  cursor: pointer;
  font-size: 16px;
  text-wrap: nowrap;
  transition: opacity 0.6s ease, background-color 0.3s ease;
}

.timeline-btn.active { background-color: var(--accent-primary-hover); }

.timeline-buttons:hover > :not(:hover) { opacity: 0.4; }
</style>
